import { QuestionRoundIcon } from "@vericus/cadmus-icons";
import { Pill, Text, Tooltip, vars } from "@vericus/cadmus-ui";

interface ProvisionalFeedbackPillProps {
  /**
   * Whether to use the basic pill variant
   * @default true
   */
  basic?: boolean;
  /**
   * Custom pill background color
   * @default vars.colors.bgrey300
   */
  pillColor?: string;
  /**
   * Custom pill text color
   * @default vars.colors.neutralBlack300
   */
  textColor?: string;
  /**
   * Custom label text
   * @default "Provisional Feedback"
   */
  label?: string;
  /**
   * Side where the tooltip appears
   * @default "bottom"
   */
  tooltipSide?: "top" | "right" | "bottom" | "left";
}

/**
 * ProvisionalFeedbackPill component that displays a pill with "Provisional Feedback"
 * text and an info icon with a tooltip explaining that this is not the final grade.
 *
 * This component is used across multiple feedback views to maintain consistency
 * in how provisional feedback is communicated to students.
 */
export function ProvisionalFeedbackPill({
  basic = true,
  pillColor = vars.colors.bgrey300,
  textColor = vars.colors.neutralBlack300,
  label = "Provisional Feedback",
  tooltipSide = "bottom",
}: ProvisionalFeedbackPillProps) {
  return (
    <>
      <Pill basic={basic} color={pillColor} textColor={textColor}>
        {label}
      </Pill>
      <Tooltip
        content={
          <Text kind="bodyLine">
            This is NOT your final grade. The
            <br />
            final feedback will be released
            <br />
            separately by your instructor.
          </Text>
        }
        side={tooltipSide}
        width="auto"
      >
        <QuestionRoundIcon label="info" size={20} />
      </Tooltip>
    </>
  );
}
